module.exports =

  directory: [
    '/'
    '/about/'
    '/service/'
    '/workflow/'
    '/works/'
    '/recruit/'
    '/contact/'
  ]

  params: []

  minWidth : 1000
  minHeight: [0, 0, 0, 0, 0, 0, 0]

  title      : []
  description: []
  keywords   : []

  location: 0



// WEBPACK FOOTER //
// ./webpack/requires/pc/data.coffee